export default "__VITE_ASSET__BxVBC19z__"